import { CalendarTableSettingsView } from '@app/model/company_hotel/settings/CalendarTableSettingsView';

// The layout that the rates table shows. The Hotel based table is hidden: the table always shows the
// Date based table, whatever layout the hotel saved. The saved value stays unchanged in the settings,
// and the settings saves (Pickup Windows, column order) send it back as it is. To bring the Hotel based
// table back, read `companyHotel.settings.calendarTable.view` again and show SelectCalendarTableViewFragment
// in MarketStatePage.
export const DISPLAYED_CALENDAR_TABLE_VIEW: CalendarTableSettingsView = CalendarTableSettingsView.CLASSIC;
